// [AI_START::module id="parseMessageContent_module" purpose="Decode chat attachment JSON whether the API wrapped it once or twice so the gallery can render" links=["Message", "Messages"]]
import type { MessageContentItemOutput } from "~@/graphql/codegen/generated";

// [AI_START::function id="parseMessageContent" purpose="Accept a list, a JSON array string, or a double-encoded JSON array string from getChatRoomMessages" links=["Message", "Messages"]]
const parseMessageContent = (
  raw: unknown
): MessageContentItemOutput[] | undefined => {
  if (raw == null || raw === "") {
    return undefined;
  }

  let value: unknown = raw;
  for (let i = 0; i < 2; i += 1) {
    if (typeof value !== "string") {
      break;
    }

    try {
      value = JSON.parse(value);
    } catch {
      return undefined;
    }
  }

  if (!Array.isArray(value)) {
    return undefined;
  }

  return value as MessageContentItemOutput[];
};
// [AI_END::parseMessageContent]

export default parseMessageContent;
// [AI_END::parseMessageContent_module]
